export interface IQuery { }

export class ResourceCapacityPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Resources.Queries.ResourceCapacityPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ResourceId: string

	constructor (workspaceId: number, strategyId: string, resourceId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ResourceId = resourceId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Resources.Queries.ResourceCapacityPageQueryV1, TCh.Domain.Quest'
	}

}

export class ResourcesByStrategyIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Resources.Queries.ResourcesByStrategyIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Resources.Queries.ResourcesByStrategyIdQueryV1, TCh.Domain.Quest'
	}

}

export class ResourceUnitCostsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Resources.Queries.ResourceUnitCostsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Resources.Queries.ResourceUnitCostsQueryV1, TCh.Domain.Quest'
	}

}

